<template>
  <div >
    <action-icon icon="FileIcon" :tooltip="$t('file')" @click="showFile()" :id="loadingPage" class="vs-con-loading__container"/>
    <vs-popup  :title="title" :active.sync="popupActive"  @close="closeValidateModal()" id="repse-file-viewer" >
      <div v-if="popupActive" >
        
        <vs-tabs v-if="files.length > 0" >
          <vs-tab
            v-for="(file, index) in files"
            :label="file.name"
            :key="index"
          >
            <div class="tab-text">
              <iframe
                :src="`${baseUrl}${file.file}` "
                class="w-full show-pdf"
                :style="{ height: '70vh'}"
              ></iframe>
            </div>
          </vs-tab>
        </vs-tabs>
        <div v-else-if="loading" style="height:400px">

        </div>
        <div v-else style="height:400px" >
             {{ $t('without_documents') | capitalize }}
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import repse from '../../requests/repse.js'
import loading from '@/mixins/Loading'
import { BASE_URL } from '@/urls.js'

export default {
  components: {
    ActionIcon,
  },
  mixins: [loading],
  data: () => ({
    files: [],
    baseUrl: BASE_URL + 'storage/',
    popupActive: false,
    loading:true
  }),
  computed:{
    loadingPage(){
      return 'repse-requests-loading'
    } 
  },
  methods: {
    showFile(){
        this.getFiles()
    },
    getFiles(){
      this.openLoading(this.loadingPage)
      repse
        .getFiles({'request_id': this.request_id})
        .then((response) => {
          this.loading = false
          if(response.data.files.length > 0){
            this.popupActive = true
            this.files = response.data.files
          }else{
            this.$vs.notify({
            color: 'warning',
            title: 'warning',
            text: this.$i18n.messages[this.$i18n.locale].no_assigned_documents,
          })
          }
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          
          this.closeLoading(this.loadingPage)
          this.showValidationErrors(response)
        })
    },
    closeValidateModal(){
      this.files = []
      this.loading = true
    }
  },
  props: {
    request_id: {
      type: String,
      default: '0',
    },
    title:{
      type: String,
      default: 'start date',
    }
  }
}
</script>
<style>

.show-pdf {
  display: block;
  border: none;
}

#repse-file-viewer > div.vs-popup {
  width: calc(100% - 30px) !important;
}
</style>